import { render, staticRenderFns } from "./LinkToStore.vue?vue&type=template&id=146fe92b"
import script from "./LinkToStore.vue?vue&type=script&lang=js"
export * from "./LinkToStore.vue?vue&type=script&lang=js"
import style0 from "./LinkToStore.vue?vue&type=style&index=0&id=146fe92b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports